import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {bindActionCreators} from "redux";

import {Button, Card, Form, InputNumber, notification} from 'antd';

import {correctReceivedProduct, getProduct, getProductStock, getProductStockBatch} from './actions';
import {getDescriptionFromError} from "../utils/errors";
import {formItemLayout} from "../utils/style";
import DateTimeDisplay from "../common/DateTimeDisplay";
import StockDisplay from "./StockDisplay";
import {decodeParams} from "../utils/params";

const FormItem = Form.Item;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class CorrectReceivedProductForm extends Component {
  static propTypes = {
    form: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,

    loading: PropTypes.bool.isRequired,
    product: PropTypes.object,
    productStock: PropTypes.object,
    productStockBatch: PropTypes.object,

    correctReceivedProduct: PropTypes.func.isRequired,
    getProduct: PropTypes.func.isRequired,
    getProductStock: PropTypes.func.isRequired,
    getProductStockBatch: PropTypes.func.isRequired,
  };

  getTransformedParams() {
    const {productId, sku, receivedAt} = decodeParams(this.props.match.params);
    return {
      productId,
      sku: sku === '-' ? '' : sku,
      receivedAt: receivedAt === '-' ? null : receivedAt,
    };
  }

  componentDidMount() {
    this._load();
  }

  componentDidUpdate(prevProps) {
    const prevParams = prevProps.match.params;
    const params = this.props.match.params;
    if ( prevParams.productId !== params.productId
      || prevParams.sku !== params.sku
      || prevParams.receivedAt !== params.receivedAt) this._load();
  }

  _load() {
    const {getProduct, getProductStock, getProductStockBatch} = this.props;
    const {productId, sku, receivedAt} = this.getTransformedParams();
    getProduct({productId});
    getProductStock({productId, sku});
    getProductStockBatch({productId, sku, receivedAt});
  }

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        const {productId, sku} = this.getTransformedParams();
        const {receivedAt, initial} = this.props.productStockBatch;
        await this.props.correctReceivedProduct({
          ...values, productId, sku, ...(initial ? {receivedAt: null} : {receivedAt})
        });
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {
      form: {getFieldDecorator, getFieldsError},
      loading, product, productStock, productStockBatch,
    } = this.props;
    return (
      <Card title="Correct Received Product">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Product"
          >
            {product && product.display}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Stock"
          >
            <StockDisplay stock={productStock}/>
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Received At"
          >
            <DateTimeDisplay dateTime={productStockBatch && productStockBatch.receivedAt}/>
            {productStockBatch && productStockBatch.initial && ' (Initial Stock)'}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Quantity"
          >
            {getFieldDecorator('quantity', {
              initialValue: productStockBatch && productStockBatch.quantity,
              rules: [
                {required: true, message: 'Quantity is required'}
              ]
            })(
              <InputNumber />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Net Cost Per Unit"
          >
            {getFieldDecorator('netCostPerUnit', {
              initialValue: productStockBatch && productStockBatch.netCostPerUnit,
              rules: [
                {required: true, message: 'Net cost per unit is required'}
              ]
            })(
              <InputNumber />
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Correct Received Product
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

const CorrectReceivedProductPage = Form.create()(CorrectReceivedProductForm);

const mapStateToProps = ({product}) => ({
  loading: product.productLoading || product.gettingProductStock || product.gettingProductStockBatch
    || product.correctingReceivedProduct,
  product: product.product,
  productStock: product.productStock,
  productStockBatch: product.productStockBatch,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  correctReceivedProduct,
  getProduct,
  getProductStock,
  getProductStockBatch,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CorrectReceivedProductPage);



// WEBPACK FOOTER //
// ./src/Product/CorrectReceivedProductPage.js